export type MenuManagementListQueryParams = {
  associateBrandId: string;
  currentPage: number;
  limit: number;
  title: string;
};

export const menuManagementListQueryParams = (
  params: MenuManagementListQueryParams
): `?associate_brand_id=${string}&current_page=${string}&limit=${string}&title=${string}` => {
  const {
    associateBrandId: associatebrandId,
    currentPage,
    limit,
    title,
  } = params;
  return `?associate_brand_id=${associatebrandId}&current_page=${currentPage.toString()}&limit=${limit.toString()}&title=${title}` as const;
};
